import { render } from "./clipboard-check.vue?vue&type=template&id=f0786bd2"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/clipboard-check.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f0786bd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f0786bd2', __exports__)) {
    api.reload('f0786bd2', __exports__)
  }
  
  module.hot.accept("./clipboard-check.vue?vue&type=template&id=f0786bd2", () => {
    api.rerender('f0786bd2', render)
  })

}


export default __exports__